import React, { useState, useEffect } from 'react';
import { FaShareAltSquare, FaFacebook, FaFacebookMessenger, FaSms } from 'react-icons/fa';
import { CiLink } from "react-icons/ci";
import { FaXTwitter } from "react-icons/fa6";
import { MdOutlineMail } from "react-icons/md";

const ShareGridient = ({position}) => {
    const [showShareButton, setShowShareButton] = useState(false);
    const [copied, setCopied] = useState(false);
    const [isSupported, setIsSupported] = useState(false);
    const actualUrl = 'https://gridient-signup.com';
    const actualQuote = 'Ready to save on your electric bill? Sign up and let us handle it for you with our AI-powered algorithms!';
    const sharedUrl = encodeURIComponent(actualUrl);
    const quote = encodeURIComponent(actualQuote);
    if (!position){
        position = 'center'
    }
    useEffect(() => {
        if (navigator.share) {
            setIsSupported(true);
        }
    }, []);

    if (!showShareButton) {
        return (
            <div className="button-container" style={{ justifyContent: position }}>
                <button
                    type="button"
                    style={{ backgroundColor: 'blue' }}
                    onClick={() => {
                        if (isSupported) {
                            navigator.share({
                                title: 'Gridient',
                                text: actualQuote,
                                url: actualUrl
                            })
                                .then(() => console.log('Share successful'))
                                .catch(err => console.error('Error sharing:', err));
                        } else {
                            setShowShareButton(true);
                        }
                    }}
                >Share Gridient With Friends <FaShareAltSquare />
                </button>
            </div>
        );
    }
    return (
        <div>
            <h1 style={{ color: 'green', display: 'flex', justifyContent: 'center' }}>Share Gridient With Friends</h1>
            <div className="share-button-container" style={{ marginTop: '20px' }}>
                <button
                    type="button"
                    onClick={async () => {
                        navigator.clipboard.writeText('https://www.gridient-signup.com/')
                            .then(() => console.log('Text copied to clipboard'))
                            .catch(err => console.error('Failed to copy: ', err));
                        setCopied(true);
                    }}>
                    <CiLink />
                </button>
                <button
                    type="button"
                    onClick={() => {
                        const shareUrl = `https://www.messenger.com/t/?link=${sharedUrl}&quote=${quote}`;
                        window.open(shareUrl, '_blank');
                    }}>
                    <FaFacebookMessenger />
                </button>
                <button
                    type="button"
                    onClick={() => {
                        const shareUrl = `https://x.com/intent/tweet?url=${sharedUrl}&text=${quote}`;
                        window.open(shareUrl, '_blank');
                    }}>
                    <FaXTwitter />
                </button>
                <button
                    type="button"
                    onClick={() => {
                        const subject = encodeURIComponent('Gridient Signup');
                        const shareUrl = `mailto:?subject=${subject}&body=${quote} ${sharedUrl}`;
                        window.open(shareUrl, '_blank');
                    }}>
                    <MdOutlineMail />
                </button>
                <button
                    type="button"
                    onClick={() => {
                        const shareUrl = `sms:?body=${quote} ${sharedUrl}`;
                        window.open(shareUrl, '_blank');
                    }}>
                    <FaSms />
                </button>
            </div>
            {copied && <div style={{ color: 'green', marginTop: '10px' }}>Link copied!</div>}
        </div>
    );
};

export default ShareGridient;
